import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";
import { useNavigate } from "react-router-dom";

import mafiaImg from "../../assets/imgs/crime/criminal.png";
import logoImg from "../../assets/imgs/crime/siren.png";

import useStyles from "./caught.styles";

interface CrimeCaughtPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CrimeCaughtPopup: React.FC<CrimeCaughtPopupProps> = ({
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleClose = () => {
    setOpenModal(false);

    navigate("/injail");
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>You got caught!</Box>
          <Box component={"img"} src={mafiaImg} className={classes.mafiaImg} />
          <Box className={classes.tryAgainText}>You are in jail.</Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CrimeCaughtPopup;
